import { render, staticRenderFns } from "./ConfigInfo.vue?vue&type=template&id=4835774d&"
import script from "./ConfigInfo.vue?vue&type=script&lang=js&"
export * from "./ConfigInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConfigInfo.vue?vue&type=style&index=0&rel=stylesheet%2Fless&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports